import { render, staticRenderFns } from "./CLoaderRing.vue?vue&type=template&id=638831da"
import script from "./CLoaderRing.vue?vue&type=script&lang=js"
export * from "./CLoaderRing.vue?vue&type=script&lang=js"
import style0 from "./CLoaderRing.vue?vue&type=style&index=0&id=638831da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports